module.exports = __webpack_public_path__ + "static/media/legal-header-image.a084489c.png";